<template>
  <form method="post">
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <!-- <div slot="header">
            <strong>{{caption}}</strong>
          </div>-->

          <b-row>
            <b-col sm="12" v-if="errores.length">
              <b-alert show variant="danger">
                <b>Por favor corrige los siguientes errores:</b>
                <ul>
                  <li v-for="error in errores" :key="error">{{ error }}</li>
                </ul>
              </b-alert>
            </b-col>
          </b-row>

          <form-wizard
            @on-complete="addDebtor()"
            shape="square"
            color="#20a8d8"
            :title="title"
            :subtitle="subtitle"
            :nextButtonText="nextButtonText"
            :backButtonText="backButtonText"
            :finishButtonText="finishButtonText"
          >
            <tab-content title="Información de la cuenta" icon="icon-user">
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbCuenta">Cuenta</label>
                    <b-form-select
                      v-model="debtor.customer_id"
                      id="cmbCuenta"
                      @change="changeCustomer(debtor.customer_id)"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstCustomers"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.business_name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbAgreement">Contrato</label>
                    <b-form-select
                      v-model="debtor.agreement_id"
                      id="cmbAgreement"
                      @change="getServiceOrders(debtor.agreement_id)"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstAgreements"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.number }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group>
                    <label for="cmbServiceOrder">Orden de servicio</label>
                    <b-form-select v-model="debtor.service_order_id" id="cmbSrviceOrder">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstServiceOrders"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.number }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="cmbEstado">Estado</label>
                    <b-form-select v-model="debtor.status" id="cmbEstado" :disabled="!isAdmin">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option value="P">Pausado</option>
                      <option value="A">Activo</option>
                      <option value="C">Cerrado</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group>
                    <label for="cmbEtapa">Etapa de cobro</label>
                    <b-form-select v-model="debtor.process_id" id="cmbEtapa" @change="getTypes()">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstProcess"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4" v-if="debtor.process_id == 1">
                  <b-form-group>
                    <label for="cmbStaff">Cobrador asignado</label>
                    <b-form-select id="cmbStaff" v-model="debtor.staff_id">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstCollectors"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }} {{ item.last_name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="4" v-if="debtor.process_id != 1">
                  <b-form-group>
                    <label for="cmbStaff">Abogado asignado</label>
                    <b-form-select id="cmbStaff" v-model="debtor.staff_id">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstLawyers"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }} {{ item.last_name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group>
                    <label for="cmbType">Tipificación</label>
                    <b-form-select
                      v-model="debtor.type"
                      id="cmbType"
                      :disabled="role_id == 1 ? false : true"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstType"
                        :key="item.id"
                        :value="item.id"
                        :disabled="item.disabled"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group>
                    <label for="cmbCurrency">Divisa</label>
                    <b-form-select
                      v-model="debtor.currency_type"
                      id="cmbCurrency"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>
                      <option
                        v-for="item in lstCurrencies"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </tab-content>

            <tab-content title="Información del deudor" icon="icon-wallet">
              <b-row>
                <b-col sm="5">
                  <b-form-group>
                    <label for="txtNombre">Razón social / Nombre</label>
                    <b-form-input type="text" id="txtNombre" v-model="debtor.business_name"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group>
                    <label for="cmbTipoDocumento">Tipo documento</label>
                    <b-form-select v-model="debtor.identification_type" id="cmbTipoDocumento">
                      <template slot="first">
                        <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                      </template>

                      <option
                        v-for="item in lstTipoDocumento"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.name }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group>
                    <label for="txtIdentificacion">Identificación</label>
                    <b-form-input
                      type="text"
                      id="txtIdentificacion"
                      v-model="debtor.identification"
                      @blur="darDigitoVerificacion"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="1">
                  <b-form-group>
                    <label for="txtDigitoVerificacion">DV</label>
                    <b-form-input
                      type="text"
                      id="txtDigitoVerificacion"
                      v-model="debtor.check_digit"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- INICIO INFORMACIÓN DE LA CONTACTO Y UBICACIÓN -->

              <b-form-group>
                <hr />
                <h4>Datos de contacto</h4>
              </b-form-group>

              <div
                v-for="(itemAddress, index) of debtor.lstAddress"
                :key="itemAddress.id"
                :value="itemAddress.id"
                class="container-box switch-custom"
              >
                <b-form-group>
                  <c-switch
                    v-model="itemAddress.status"
                    class="ml-3 mb-2"
                    color="primary"
                    label
                    variant="pill"
                    v-bind="labelTxt"
                    :size="'sm'"
                  />

                  <button
                    class="btn btn-sm btn-danger float-right"
                    type="button"
                    @click="eliminarDireccion(index)"
                    title="Eliminar"
                  >
                    <!-- Eliminar -->
                    <i class="fa fa-trash"></i>
                  </button>
                </b-form-group>

                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="txtDireccion">Dirección</label>
                      <b-form-input type="text" id="txtDireccion" v-model="itemAddress.address"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="txtBarrio">Barrio</label>
                      <b-form-input type="text" id="txtBarrio" v-model="itemAddress.neighborhood"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="cmbDepartamento">Departamento</label>
                      <b-form-select
                        id="cmbDepartamento"
                        v-model="itemAddress.zone_id"
                        @change="getCitiesByZoneAddress(itemAddress)"
                      >
                        <template slot="first">
                          <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                        </template>

                        <option
                          v-for="item in itemAddress.lstDepartamento"
                          :key="item.id"
                          :value="item.id"
                        >{{ item.name }}</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="cmbCiudad">Ciudad</label>
                      <b-form-select id="cmbCiudad" v-model="itemAddress.city_id">
                        <template slot="first">
                          <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                        </template>

                        <option
                          v-for="item in itemAddress.lstCiudad"
                          :key="item.id"
                          :value="item.id"
                        >{{ item.name }}</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label>Celular</label>
                      <tags-input
                        placeholder="# celular"
                        v-model="itemAddress.lstMobile"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <label class="text-danger">Celular Negativo</label>
                      <tags-input
                        placeholder="# celular"
                        v-model="itemAddress.lstMobileN"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="4">
                    <b-form-group>
                      <label>Teléfono</label>
                      <tags-input
                        placeholder="# telefono"
                        v-model="itemAddress.lstPhone"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label class="text-danger">Teléfono Negativo</label>
                      <tags-input
                        placeholder="# telefono"
                        v-model="itemAddress.lstPhoneN"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="8">
                    <b-form-group>
                      <label for="txtTelefono">Correo electrónico</label>
                      <tags-input
                        placeholder="email.."
                        v-model="itemAddress.lstMail"
                        :add-tags-on-blur="true"
                      ></tags-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <div class="mb-2">
                <button class="btn btn-sm btn-success" type="button" @click="addAddress()">
                  Añadir dirección
                  <i class="fa fa-plus"></i>
                </button>
              </div>

              <!-- FIN INFORMACIÓN DE LA CONTACTO Y UBICACIÓN -->
            </tab-content>

            <tab-content title="Campos personalizados" icon="icon-list">
              <b-row
                v-for="(item, index) in debtor.lstCustomFieldsData"
                :key="item.id"
                :value="index"
              >
                <b-col sm="3">
                  <b-form-group>
                    <label>Nombre campo</label>
                    <b-form-input type="text" v-model="item.name" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group>
                    <label>Tipo</label>
                    <b-form-input type="text" v-model="item.type_name" :disabled="true"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="6">
                  <b-form-group>
                    <label for="txtValor">Valor</label>
                    <b-form-input type="text" id="txtValor" v-model="item.value"></b-form-input>
                  </b-form-group>
                </b-col>

                <!-- <b-col sm="1">
                  <b-form-group>
                    <label>&nbsp;</label>
                    <b-button variant="danger" @click="deleteCustomField(index)">Quitar</b-button>
                  </b-form-group>
                </b-col>-->
              </b-row>
            </tab-content>
            <tab-content title="Referencias de contacto" icon="icon-people">
              <!-- INICIO INFORMACIÓN DE CONTACTO -->
              <div
                v-for="(item, index) of debtor.lstContacto"
                :key="item.id"
                :value="item.id"
                class="container-box"
              >
                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" placeholder="Nombre" v-model="item.name"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <b-form-input type="text" placeholder="Correo" v-model="item.mail"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        title="Código País Teléfono"
                        placeholder="País Tel."
                        v-model="item.phone_zone"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        title="Código Área Teléfono"
                        placeholder="Área Tel."
                        v-model="item.phone_area"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="2">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        title="Número Teléfono"
                        placeholder="# Teléfono"
                        v-model="item.phone_number"
                        maxlength="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        title="Código País Celular"
                        type="text"
                        placeholder="País Cel."
                        v-model="item.mobile_zone"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="1">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        title="Código Área Celular"
                        placeholder="Área Cel."
                        v-model="item.mobile_area"
                        maxlength="4"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="2">
                    <b-form-group>
                      <b-form-input
                        type="text"
                        title="Número Celular"
                        placeholder="# Celular"
                        v-model="item.mobile_number"
                        maxlength="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <button
                      class="btn btn-sm btn-danger float-right"
                      type="button"
                      @click="eliminarContacto(index)"
                      title="Eliminar"
                    >
                      <!-- Eliminar -->
                      <i class="fa fa-trash"></i>
                    </button>
                  </b-col>
                </b-row>
              </div>

              <div class="mb-2">
                <button class="btn btn-sm btn-success" type="button" @click="addContact()">
                  Añadir referencia
                  <i class="fa fa-plus"></i>
                </button>
              </div>

              <!-- FIN INFORMACIÓN DE CONTACTO -->
            </tab-content>
            <tab-content title="Comentarios" icon="icon-check">
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="txtObservacion">Descripción o comentarios</label>
                    <b-form-textarea
                      rows="8"
                      id="txtObservacion"
                      no-resize
                      v-model="debtor.observation"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </tab-content>
          </form-wizard>

          <!-- <b-button @click="goBack" variant="primary" class="mr-1">Cancelar</b-button>

          <b-button type="submit" variant="success">Guardar</b-button>-->
        </b-card>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
export default {
  name: "customerAdd",
  components: {
    cSwitch
  },
  props: {
    // caption: {
    //   type: String,
    //   default: "Cliente"
    // }
    title: {
      type: String,
      default: "Crear Deudor"
    },
    subtitle: {
      type: String,
      default: "Datos del deudor"
    },
    nextButtonText: {
      type: String,
      default: "Siguiente"
    },
    backButtonText: {
      type: String,
      default: "Anterior"
    },
    finishButtonText: {
      type: String,
      default: "Finalizar"
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      lstTipoDocumento: [],
      debtor: {
        business_name: "",
        type: null,
        identification_type: null,
        identification: null,
        check_digit: null,
        observation: null,
        status: "P",
        // direcciones
        lstAddress: [],
        // datos para la tabla staff_customers
        process_id: null,
        customer_id: null,
        agreement_id: null,
        service_order_id: null,
        staff_id: null, // cobrador o abogado
        // campos personalizados
        lstCustomFieldsData: [],
        // contactos o referencias
        lstContacto: [],
        currency_type: null // Tipo de divisa que maneja el deudor
      },
      datos: [],
      errores: [],
      lstCustomers: [],
      lstAgreements: [],
      lstServiceOrders: [],
      lstCollectors: [],
      lstLawyers: [],
      lstType: [],
      lstProcess: [],
      lstCurrencies: [],
      labelTxt: {
        dataOn: "Positiva",
        dataOff: "Negativa"
      }
    };
  },
  mounted() {
    // TIPIFICACIÓN
    this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
      response => {
        response.data.data.forEach(item => {
          item.disabled = false;

          // 55: Castigado
          // 56: Devuelto (Otros)
          // 57: Enviar a demanda
          // 64: Suspendido
          // 81: Devuelto por reorganización
          // 82: Devuelto por liquidación
          if (
            item.id == 55 ||
            item.id == 56 ||
            item.id == 57 ||
            item.id == 64 ||
            item.id == 81 ||
            item.id == 82
          ) {
            item.disabled = this.role_id == 1 ? false : true;
          }

          // if (item.id == 64 && this.role_id == 4) item.disabled = false;

          this.lstType.push(item);
        });
        // this.lstType = response.data.data;
      },
      error => {
        console.log(error);
      }
    );

    // LISTA DE CUENTAS
    var auth = localStorage.getItem("auth");
    let authAux = JSON.parse(auth);
    let url = `${this.$urlApi}customers/staff?token=${this.token}`;
  
    if (this.role_id != 1 && this.role_id != 7 && this.role_id != 8) 
    {
      authAux[0].filter_staff_id = authAux[0].staff_id;
    }
    else 
    {
      authAux[0].filter_staff_id = null;
    }

    console.log('authAux -----------------------------------------', authAux);

    this.$http
      .post(url, JSON.stringify(authAux), {
        headers: { "Content-Type": "application/json" }
      })
      .then(
        response => {
          // console.log(response);
          this.lstCustomers = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

    // TIPOS DE DOCUMENTO
    this.$http.get(`${this.$urlApi}parameters/2?token=${this.token}`).then(
      response => {
        this.lstTipoDocumento = response.data.data;
      },
      error => {
        console.log(error);
      }
    );

    //COBRADORES => 43: Prejurídico
    this.$http.get(`${this.$urlApi}staffs/collector?token=${this.token}`).then(
      response => {
        this.lstCollectors = response.data.data;
        hideLoader();
      },
      error => {
        console.log(error);
      }
    );

    //ABOGADOS => 44: Jurídico
    this.$http.get(`${this.$urlApi}staffs/type/44?token=${this.token}`).then(
      response => {
        this.lstLawyers = response.data.data;
        hideLoader();
      },
      error => {
        console.log(error);
      }
    );

    // PROCESOS
    this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
      response => {
        this.lstProcess = response.data.data;
      },
      error => {
        console.log(error);
      }
    );

    // 19: IPOS DE DIVISAS
    this.$http.get(`${this.$urlApi}parameters/19?token=${this.token}`).then(
      response => {
        this.lstCurrencies = response.data.data;
      },
      error => {
        console.log(error);
      }
    );

    //LISTADO DE DIRECCIONES, POR DEFECTO SE COLOCA UNO
    this.addAddress();
    //LISTADO DE CONTACTOS, POR DEFECTO SE COLOCA UNO
    // this.addContact();
  },
  computed: {},
  methods: {
    addDebtor() {
      showLoader();
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.errores = null;
      this.debtor.url = `${location.origin}/#/debtors/view/`;
      this.debtor.auth_is_admin = this.isAdmin;
      this.debtor.user_id = auth[0].id;

      this.datos = JSON.stringify(this.debtor);

      //console.log(this.datos)
      this.$http
        .post(`${this.$urlApi}debtors/store?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" }
        })
        .then(function(response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              location.href = `${location.origin}/#/debtors`;
            }
          });
        })
        .catch(error => {
          this.errores = getMsgError(error);
          console.log(error);
          hideLoader();
        });
    },
    getTypes() {

      this.lstType = [];

      if(this.debtor.process_id == 1) {
        this.debtor.type = 77;
        // TIPIFICACIÓN DEUDOR PREJURIDICO
        this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
          (response) => {
            this.lstType = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        this.debtor.type = 203;
        // TIPIFICACIÓN DEUDOR JURIDICO
        this.$http.get(`${this.$urlApi}parameters/20?token=${this.token}`).then(
          (response) => {
            this.lstType = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );
      }
      // PARA LAS DEMAS ETAPAS NO HAY TIPIFICACIONES

    },
    goBack() {
      this.$router.go(-1);
    },
    darDigitoVerificacion() {
      this.debtor.check_digit = calcularDigitoVerificacion(
        this.debtor.identification
      );
    },
    addAddress() {
      // -------------------------------------------------------------------------------------------------
      // ATRIBUTOS PARA LA GESTIÓN DE LA DIRECCIÓN
      // -------------------------------------------------------------------------------------------------

      let addressAux = {
        id: null,
        address: null,
        neighborhood: null,
        zone_id: null,
        city_id: null,
        status: true,
        lstPhone: [],
        lstPhoneN: [],
        lstMobile: [],
        lstMobileN: [],
        lstMail: [],
        lstDepartamento: [],
        lstCiudad: []
      };
      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        response => {
          addressAux.lstDepartamento = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      this.debtor.lstAddress.push(addressAux);
      // -------------------------------------------------------------------------------------------------
      // FIN GESTIÓN DIRECCIÓN
      // -------------------------------------------------------------------------------------------------
    },
    changeCustomer(customer_id) {
      this.getAgreements(customer_id);
      this.getCustomFields(customer_id);
    },
    getCustomFields(customer_id) {
      showLoader();

      // CARGAR EL LISTADO DE CAMPOS PERSONALIZADOS
      this.$http
        .get(
          `${this.$urlApi}customfields/customer/${customer_id}?token=${this.token}`
        )
        .then(
          response => {
            var lstCustomFields = response.data.data;

            for (let i = 0; i < lstCustomFields.length; i++) {
              const item = lstCustomFields[i];
              var customFieldsData = {
                custom_field_id: item.id,
                name: item.name,
                type_name: item.type_name,
                value: null
              };
              this.debtor.lstCustomFieldsData.push(customFieldsData);
            }

            hideLoader();
          },
          error => {
            console.log(error);
            hideLoader();
          }
        );

      hideLoader();
    },
    getAgreements(customer_id) {
      showLoader();
      // CARGAR EL LISTADO DE ACUERDOS
      var status = "A";
      this.$http
        .get(
          `${this.$urlApi}agreements/customer/${customer_id}/status/${status}?token=${this.token}`
          // `${this.$urlApi}agreements/customer/${customer_id}?token=${this.token}`
        )
        .then(
          response => {
            this.lstAgreements = response.data.data;
          },
          error => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );
    },
    getServiceOrders(agreement_id) {
      showLoader();
      // CARGAR EL LISTADO ORDENES DE SERVICIO
      var status = "A";
      this.$http
        .get(
          `${this.$urlApi}serviceorders/agreement/${agreement_id}/status/${status}?token=${this.token}`
        )
        .then(
          response => {
            this.lstServiceOrders = response.data.data;
          },
          error => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );
      hideLoader();
    },
    getCitiesByZoneAddress(item) {
      showLoader();
      if (item.zone_id) {
        this.$http
          .get(`${this.$urlApi}cities/${item.zone_id}?token=${this.token}`)
          .then(
            response => {
              item.lstCiudad = response.data.data;
              item.city_id = null;
              hideLoader();
            },
            error => {
              console.log(error);
              hideLoader();
            }
          );
      }
    },
    deleteCustomField(index) {
      this.$delete(this.debtor.lstCustomFieldsData, index);
    },
    addContact() {
      let contactoAux = {
        id: null,
        name: null,
        // last_name: null,
        // occupation: null,
        mail: null,
        phone_number: null,
        phone_zone: null,
        phone_area: null,
        mobile_number: null,
        mobile_zone: null,
        mobile_area: null
        // birthday_date: null
      };

      this.debtor.lstContacto.push(contactoAux);
    },
    eliminarDireccion(index) {
      this.$delete(this.debtor.lstAddress, index);
    },
    eliminarContacto(index) {
      this.$delete(this.debtor.lstContacto, index);
    }
  }
};
</script>
